import { styled } from '@styledComponents';
import { themeMediaQuery } from '@utils/styledTheme.util';
import { Columns } from '@components/Columns';
import { TextPairing } from '@components/TextPairing';
import { CloudImage, PlaceholderCloudImage } from '@components/CloudImage';
import { Box } from '@components/Box';
import { themeSpace } from '@utils/styledTheme.util';

export const MatchingStationeryWrapper = styled(Box)`
  position: relative;
  background: #fef3ea;
`;

export const SaveTheDatesTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 565px;
  }
  .text-pairing-body {
    max-width: 575px;
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-title {
      max-width: 294px;
    }
    .text-pairing-body {
      max-width: 276px;
    }
  }
  ${themeMediaQuery('sm')} {
    .text-pairing-title {
      max-width: 430px;
    }
    .text-pairing-body {
      max-width: 490px;
    }
  }
`;

export const CloudImageWrapper = styled(Box)`
  ${themeMediaQuery('sm')} {
    display: block;
    position: relative;
  }
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

const StyledPlaceholderCloudImage = styled(PlaceholderCloudImage)`
  ${themeMediaQuery('sm')} {
    width: 688px;
    height: 431px;
  }
  ${themeMediaQuery('md')} {
    width: 1032px;
    height: 647px;
  }
  ${themeMediaQuery('lg')} {
    width: 1224px;
    height: 767px;
  }
`;

export const StaticPlaceholderCloudImage = styled(StyledPlaceholderCloudImage)`
  ${themeMediaQuery('sm')} {
    display: block;
    position: absolute;
  }
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const TopPlaceholderCloudImage = styled(PlaceholderCloudImage)`
  ${themeMediaQuery('sm')} {
    display: block;
    position: absolute;
    animation-name: fadeTop;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
    animation-duration: 2s;
    animation-direction: alternate;

    @keyframes fadeTop {
      0% {
        opacity: 1;
      }
      25% {
        opacity: 1;
      }
      75% {
        opacity: 0;
      }
      100% {
        opacity: 0;
      }
    }
    width: 660px;
    height: 431px;
  }
  ${themeMediaQuery('md')} {
    width: 990px;
    height: 647px;
  }
  ${themeMediaQuery('lg')} {
    width: 1175px;
    height: 767px;
  }
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const BottomPlaceholderCloudImage = styled(StyledPlaceholderCloudImage)`
  ${themeMediaQuery('sm')} {
    display: block;
    animation-name: fadeBottom;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
    animation-duration: 2s;
    animation-direction: alternate;

    @keyframes fadeBottom {
      0% {
        opacity: 0;
      }
      25% {
        opacity: 0;
      }
      75% {
        opacity: 1;
      }
      100% {
        opacity: 1;
      }
    }
  }
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const MobilePlaceholderCloudImage = styled(PlaceholderCloudImage)`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
    width: 100%;
    height: auto;
  }
`;

export const StyledCtaColumns = styled(Columns)`
  @media (min-width: 36rem) and (max-width: 52.063rem) {
    min-width: 30rem;
    padding: initial;
  }
`;

export const StyledCtaColumn = styled(Columns.Column)`
  @media (min-width: 36rem) and (max-width: 52.063rem) {
    width: 50%;
    display: inline-block;
  }
`;

export const CtaColumnLeft = styled(StyledCtaColumn)`
  text-align: right;
  padding-right: ${themeSpace(7)};
  ${themeMediaQuery('below_sm')} {
    text-align: center;
    padding: initial;
  }
`;

export const CtaColumnRight = styled(StyledCtaColumn)`
  text-align: left;
  padding-left: ${themeSpace(7)};
  ${themeMediaQuery('below_sm')} {
    text-align: center;
    padding: initial;
  }
  @media (min-width: 36rem) and (max-width: 52.063rem) {
    padding-left: 0;
  }
`;

export const BottomWave = styled(CloudImage)`
  width: 100%;
  height: 150px;
  object-fit: cover;
  position: absolute;
  bottom: -85px;
  object-position: top;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const DesktopBoxContainer = styled.div`
  display: block;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const MobBoxContainer = styled.div`
  display: block;
  ${themeMediaQuery('sm')} {
    display: none;
  }
`;
